/**
 * EvidenceViewerPage — route entry for the admin Evidence Viewer module
 * (ODE-P07-T05). Applies the client-side permission mirror (UX only — the
 * server-side OD-015 `evidence.view` guard on every endpoint remains the
 * authority) and renders the module. Test seams are passed through (no real
 * fetch in tests).
 *
 * Traces to: ODE-PRD-REQ-047, ODE-PRD-REQ-077, ODE-PRD-REQ-090.
 */

import { useAuth } from '../../auth/AuthContext.js';
import { StateView } from '../../components/StateView.js';
import { hasPermission } from '../../rbac/catalog.js';
import { EvidenceViewerModule, type EvidenceViewerSeams } from './EvidenceViewerModule.js';

export function EvidenceViewerPage({
  seams,
}: { readonly seams?: EvidenceViewerSeams } = {}): JSX.Element {
  const { session } = useAuth();
  const allowed = session !== null && hasPermission(session.staff.roles, 'evidence.view');
  if (!allowed) {
    return (
      <StateView
        state={{
          kind: 'blocked',
          message: 'Peran tidak memiliki izin evidence.view untuk halaman ini.',
        }}
      />
    );
  }
  return <EvidenceViewerModule seams={seams ?? {}} />;
}